import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { snack } from '~/hooks/ToastProvider';

/**
 * After a Swan membership binding, the backend redirects the invited user back to the app root.
 * When the binding is rejected because the phone is already tied to another member of the account,
 * it appends `?status=error&errorCode=phone_already_bound`. Since the landing route immediately
 * navigates away (dropping the query string), we snapshot the initial URL on mount and surface a
 * meaningful toast once.
 */
const MembershipRedirectChecker: React.FC = () => {
  const { t } = useTranslation('settings', { keyPrefix: 'team.alerts' });
  const [initialSearch] = useState(() => window.location.search);
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    const params = new URLSearchParams(initialSearch);
    if (params.get('status') === 'error' && params.get('errorCode') === 'phone_already_bound') {
      snack.error(t('phone_already_bound'));
    }
  }, [initialSearch, t]);

  return null;
};

export default MembershipRedirectChecker;
